import axios from "axios";
import { BASE_URL } from "../constants";
import getHeaders from "../constants/headers";

export const addUser = (data) => {
  return axios({
    method: "post",
    url: BASE_URL + "api/secure/v1/user",
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const getUser = () => {
  return axios({
    method: "get",
    url: BASE_URL + "api/secure/v1/user",
    headers: getHeaders(),
  });
};

export const updateUser = (data) => {
  return axios({
    method: "put",
    url: BASE_URL + "api/secure/v1/user",
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

